<app-input-container [label]="label" [obrigatorio]="obrigatorio">
    <input currencyMask [maxlength]="maxLength" [attr.disabled]="getAtivo()?null:'disableb'" #campo type="text"
      class="form-control form-control-sm" [name]="name" [(ngModel)]="value" [placeholder]="placeholder"
      autocomplete="false" [options]="{ prefix: ' ', thousands: '.', decimal: ',', align: 'left' }"/>
  </app-input-container>